{
  "language": {
    "name": "ไทย"
  },
  "nav": {
    "about": "เกี่ยวกับ",
    "expertise": "ความเชี่ยวชาญ",
    "certifications": "ใบรับรอง",
    "connect": "ติดต่อ"
  },
  "hero": {
    "badge": "พร้อมสำหรับบทบาทด้านสุขภาพในสิงคโปร์",
    "title": "เชื่อมความเป็นเลิศนอร์ดิกกับหัวใจเอเชียตะวันออกเฉียงใต้",
    "stats": {
      "certifications": "ใบรับรองที่ตรวจสอบแล้ว",
      "languages": "ภาษาที่พูดได้",
      "geriatric": "เน้นการดูแลผู้สูงอายุ"
    },
    "cta": {
      "download": "ดาวน์โหลด CV",
      "explore": "สำรวจโลกทั้งสองของฉัน"
    }
  },
  "worlds": {
    "title": "โลกทั้งสองของฉัน",
    "finland": {
      "title": "ฟินแลนด์: ที่ฉันได้รับการฝึกฝน",
      "points": [
        "การศึกษาด้านสุขภาพที่เข้มงวดตามหลักฐาน",
        "ใบรับรองเฉพาะทาง 20+ จาก Duodecim",
        "เน้นความปลอดภัยของผู้ป่วยและการปรับปรุงคุณภาพ",
        "ทักษะทางคลินิกขั้นสูงในระบบสุขภาพฟินแลนด์"
      ]
    },
    "asia": {
      "title": "เอเชียตะวันออกเฉียงใต้: ที่ฉันเป็นของ",
      "points": [
        "รากฐานวัฒนธรรมไทยและค่านิยมครอบครัว",
        "ความเข้าใจในความคาดหวังด้านสุขภาพของเอเชีย",
        "ความสามารถในการสื่อสารหลายภาษา",
        "ความไวทางวัฒนธรรมในการดูแลผู้ป่วย"
      ]
    },
    "bridge": {
      "title": "เชื่อมโลกทั้งสอง",
      "points": {
        "evidence": {
          "title": "การปฏิบัติตามหลักฐาน",
          "desc": "การฝึกฝนฟินแลนด์พบกับความอบอุ่นแบบเอเชีย"
        },
        "cultural": {
          "title": "ความฉลาดทางวัฒนธรรม",
          "desc": "นำทางความต้องการของผู้ป่วยที่หลากหลาย"
        },
        "tech": {
          "title": "ความเป็นเลิศทางเทคนิค",
          "desc": "ระบบสุขภาพสมัยใหม่"
        },
        "family": {
          "title": "การดูแลที่มุ่งเน้นครอบครัว",
          "desc": "แนวทางองค์รวมในการรักษา"
        }
      }
    }
  },
  "patient": {
    "title": "การสื่อสารที่มุ่งเน้นผู้ป่วย",
    "subtitle": "ฉันปรับรูปแบบการสื่อสารเพื่อตอบสนองความต้องการของผู้ป่วยที่หลากหลายอย่างไร",
    "conversations": {
      "medication": {
        "patient": "ฉันกังวลเกี่ยวกับการกินยาจำนวนมาก ลูกสาวฉันบอกว่ามันมากเกินไป",
        "nurse": "ฉันเข้าใจความกังวลของคุณ ให้ฉันอธิบายยาแต่ละชนิดและเหตุผลที่สำคัญต่อการฟื้นตัวของคุณ เราสามารถหารือเรื่องนี้กับลูกสาวของคุณและแพทย์เพื่อให้แน่ใจว่าทุกคนพอใจกับแผนการรักษา"
      },
      "pain": {
        "patient": "ความเจ็บปวดแย่ลง แต่ฉันไม่อยากรบกวนใคร",
        "nurse": "ความสบายของคุณสำคัญมากสำหรับเรา กรุณาอย่าลังเลที่จะบอกเราเกี่ยวกับความเจ็บปวดของคุณ ให้ฉันประเมินระดับความเจ็บปวดของคุณและเราจะทำงานร่วมกันเพื่อจัดการมันอย่างมีประสิทธิภาพ สุขภาพของคุณคือความสำคัญอันดับแรกของเรา"
      },
      "family": {
        "patient": "ครอบครัวของฉันสามารถอยู่กับฉันได้ไหม ฉันรู้สึกดีขึ้นเมื่อพวกเขาอยู่ที่นี่",
        "nurse": "แน่นอน การสนับสนุนของครอบครัวเป็นส่วนสำคัญของการรักษา มาจัดเวลาเยี่ยมที่เหมาะสมกับทุกคนในขณะที่ให้แน่ใจว่าคุณได้พักผ่อนเพียงพอ เราให้ความสำคัญกับการมีส่วนร่วมของครอบครัวในการดูแลของคุณ"
      }
    }
  },
  "cv": {
    "title": "ประวัติส่วนตัว",
    "sections": {
      "personalInfo": "ข้อมูลส่วนตัว",
      "summary": "สรุปอาชีพ",
      "licenses": "ใบอนุญาตและคุณสมบัติพยาบาล",
      "education": "การศึกษา",
      "experience": "ประสบการณ์อาชีพ",
      "certifications": "การพัฒนาอาชีพอย่างต่อเนื่อง",
      "skills": "ทักษะทางคลินิก",
      "languages": "ภาษา"
    },
    "personalInfo": {
      "fullName": "ชื่อเต็ม",
      "dateOfBirth": "วันเกิด",
      "nationality": "สัญชาติ",
      "contact": "ติดต่อ",
      "email": "อีเมล",
      "location": "ที่อยู่ปัจจุบัน"
    },
    "summary": "พยาบาลวิชาชีพที่ทุ่มเทด้วยการฝึกอบรมด้านสุขภาพของฟินแลนด์และใบอนุญาตพยาบาลที่ใช้งานได้ ความเชี่ยวชาญในการผ่าตัด จิตเวช การดูแลผู้สูงอายุ และการดูแลฉุกเฉิน ความสามารถที่พิสูจน์แล้วในการปฏิบัติตามหลักฐาน ความปลอดภัยของผู้ป่วย และความร่วมมือข้ามสาขา มุ่งมั่นที่จะมีส่วนร่วมในความเป็นเลิศทางคลินิกและความสามารถในการปรับตัวทางวัฒนธรรมให้กับระบบสุขภาพของสิงคโปร์",
    "licenses": {
      "nursing": {
        "title": "ใบอนุญาตพยาบาลฟินแลนด์",
        "details": "พยาบาลวิชาชีพที่ได้รับใบอนุญาต (Sairaanhoitaja) | หมายเลขทะเบียน: 10009985648 | ออกโดย: Valvira | สถานะ: ใช้งานได้"
      },
      "medication": {
        "title": "ใบอนุญาตยาฟินแลนด์",
        "details": "ประเภทใบอนุญาต: Love (Lääkkeenmääräämis Lupa hoitajille) | สถานะ: ใช้ได้"
      }
    },
    "education": {
      "degree": "ปริญญาตรีสาธารณสุข (วิทยาศาสตร์การพยาบาล)",
      "institution": "มหาวิทยาลัยวิทยาศาสตร์ประยุกต์ LAB, ลาห์ตี, ฟินแลนด์",
      "year": "ปีที่จบการศึกษา"
    },
    "experience": {
      "responsibilities": "ความรับผิดชอบหลัก",
      "achievements": "ความสำเร็จหลัก",
      "0": {
        "title": "นักศึกษาพยาบาล - หน่วยดูแลเฉียบพลัน",
        "organization": "โรงพยาบาลกลาง Päijät-Häme",
        "location": "ลาห์ตี, ฟินแลนด์",
        "period": "กุมภาพันธ์ 2025 - เมษายน 2025",
        "responsibilities": [
          "ให้การดูแลผู้ป่วยอย่างครอบคลุมในสภาพแวดล้อมการดูแลเฉียบพลัน รวมถึงการตรวจสอบสัญญาณชีพ การบริหารยา และการบันทึกในระบบบันทึกสุขภาพอิเล็กทรอนิกส์ (LifeCare)",
          "ทำขั้นตอนทางคลินิกเช่นการใส่สายน้ำเกลือ การบันทึก ECG และการแทรกแซงการดูแลผู้ป่วยต่างๆ",
          "ร่วมมือกับทีมสหสาขาวิชาชีพรวมถึงแพทย์ นักกายภาพบำบัด และเภสัชกร",
          "ประเมินสภาพผู้ป่วย ตอบสนองต่อการเปลี่ยนแปลงของสัญญาณชีพ และเพิ่มความกังวลอย่างเหมาะสม"
        ]
      },
      "1": {
        "title": "นักศึกษาพยาบาล - ห้องผ่าตัด",
        "organization": "โรงพยาบาลกลาง Etelä-Karjala",
        "location": "ลัพเพนรันตา, ฟินแลนด์",
        "period": "มกราคม 2025 - กุมภาพันธ์ 2025",
        "responsibilities": [
          "ได้รับประสบการณ์ที่ครอบคลุมในการดูแลพยาบาลช่วงผ่าตัดในทั้งสามบทบาท: พยาบาลวิสัญญี พยาบาลล้างมือ และพยาบาลหมุนเวียน",
          "ช่วยในขั้นตอนการผ่าตัดในขณะที่รักษาเทคนิคปลอดเชื้ออย่างเข้มงวดและโปรโตคอลสนามปลอดเชื้อ",
          "ตรวจสอบสัญญาณชีพของผู้ป่วยและการตอบสนองต่อการระงับความรู้สึกโดยใช้อุปกรณ์ตรวจสอบขั้นสูง"
        ]
      },
      "2": {
        "title": "พยาบาลวิชาชีพ - หอผู้ป่วยศัลยกรรม",
        "organization": "โรงพยาบาลกลาง Päijät-Häme, หอผู้ป่วย R5",
        "location": "ลาห์ตี, ฟินแลนด์",
        "period": "ธันวาคม 2024 - กุมภาพันธ์ 2025",
        "responsibilities": [
          "ให้การดูแลพยาบาลก่อนและหลังการผ่าตัดอย่างครอบคลุมสำหรับผู้ป่วยศัลยกรรมในหอผู้ป่วยดูแลเฉียบพลัน 30 เตียง",
          "บริหารยา การบำบัดทางหลอดเลือดดำ และการจัดการความเจ็บปวดตามคำสั่งแพทย์และโปรโตคอลการพยาบาล",
          "ตรวจสอบสัญญาณชีพของผู้ป่วย การหายของแผล และการฟื้นตัวหลังการผ่าตัด"
        ],
        "achievements": [
          "จัดการการดูแลผู้ป่วยหลังการผ่าตัดที่มีความรุนแรงสูงที่ต้องการการดูแลแผลที่ซับซ้อนได้สำเร็จ",
          "รักษาความแม่นยำในการบริหารยา 100% ผ่านการตรวจสอบและบันทึกอย่างระมัดระวัง"
        ]
      }
    },
    "certifications": {
      "0": {
        "category": "จิตเวชและสุขภาพจิต",
        "items": [
          "เยาวชนวิตกกังวลและนอนไม่หลับ: มุมมองจิตเวชวัยรุ่น (55 นาที) - พ.ย. 2024",
          "การสัมภาษณ์เชิงกระตุ้น (60 นาที) - ธ.ค. 2022"
        ]
      },
      "1": {
        "category": "การดูแลผู้สูงอายุและผู้สูงวัย",
        "items": [
          "การระบุความอ่อนแอของผู้สูงอายุ (30 นาที) - ต.ค. 2024",
          "การจัดการยาผู้สูงอายุ (60 นาที) - ก.ย. 2024",
          "การใช้ยาหลายชนิดในผู้สูงอายุ (40 นาที) - ก.ย. 2024",
          "การป้องกันการหกล้ม (60 นาที) - ก.ย. 2024"
        ]
      },
      "2": {
        "category": "การดูแลเฉียบพลันและฉุกเฉิน",
        "items": [
          "การประเมินฉุกเฉินผู้ป่วยทางระบบประสาท (60 นาที) - พ.ย. 2023",
          "การประเมินอย่างเป็นระบบของหน้าที่สำคัญโดยใช้หลักการ ABCDE (30 นาที) - ต.ค. 2023",
          "การใส่และใช้สายสวนหลอดเลือดดำส่วนกลาง (CVK) (70 นาที) - พ.ย. 2023"
        ]
      }
    },
    "skills": {
      "clinical": {
        "title": "ความสามารถในการดูแลผู้ป่วย",
        "items": [
          "การประเมินผู้ป่วยอย่างครอบคลุมและการตรวจสอบสัญญาณชีพ",
          "การดูแลแผลขั้นสูงและการเปลี่ยนผ้าพันแผล",
          "การบริหารยา (ทางปาก IV IM SC)",
          "การใส่สายน้ำเกลือ การสวนปัสสาวะ และการจัดการท่อ NG",
          "การประเมินและจัดการความเจ็บปวด",
          "การดูแลผู้ป่วยก่อนและหลังการผ่าตัด"
        ]
      },
      "technical": {
        "title": "ระบบเทคนิคและคลินิก",
        "items": [
          "ระบบบันทึกสุขภาพอิเล็กทรอนิกส์ (EHR) LifeCare",
          "การใช้งานอุปกรณ์ทางการแพทย์ (เครื่องตรวจสอบสัญญาณชีพ ปั๊มให้สารน้ำ ระบบส่งออกซิเจน)",
          "โปรโตคอลการควบคุมการติดเชื้อและเทคนิคปลอดเชื้อ",
          "โปรโตคอลการตอบสนองฉุกเฉินและการช่วยชีวิตขั้นพื้นฐาน"
        ]
      },
      "soft": {
        "title": "ทักษะอ่อนและคุณลักษณะทางวิชาชีพ",
        "items": [
          "ทักษะการสื่อสารและการฟังอย่างตั้งใจที่ยอดเยี่ยม",
          "ความเห็นอกเห็นใจที่แข็งแกร่งและการดูแลที่มุ่งเน้นผู้ป่วย",
          "การทำงานเป็นทีมที่มีประสิทธิภาพในสภาพแวดล้อมสหสาขาวิชาชีพ",
          "การจัดการเวลาในสภาพแวดล้อมที่มีความกดดันสูง",
          "ความไวทางวัฒนธรรมกับประชากรผู้ป่วยที่หลากหลาย"
        ]
      }
    },
    "languages": {
      "thai": "ไทย",
      "finnish": "ฟินแลนด์",
      "english": "อังกฤษ"
    },
    "languageProficiency": {
      "native": "ภาษาแม่",
      "fluent": "คล่องแคล่ว",
      "professional_b2": "ระดับมืออาชีพ (B2)"
    },
    "generated": "สร้างเมื่อ"
  },
  "footer": {
    "credentials": "พยาบาลวิชาชีพ, ปริญญาตรี (การพยาบาล)",
    "privacy": "นโยบายความเป็นส่วนตัว",
    "terms": "เงื่อนไขการใช้งาน",
    "copyright": "© {{year}} Mona. สงวนลิขสิทธิ์."
  }
}